import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateTimelineGroup = document.createElement('template');

templateTimelineGroup.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <gz-text id="title"></gz-text>
    <div class="timeline-container"></div>
    <gz-button type="outline" buttonheight="small" buttonfontsize="medium" id="viewOnGraph"></gz-button>
  </div>
`;
